import { lazier } from '@shared/components';

import CounseledYouthPagePlaceholder from './CounseledYouthPagePlaceholder';

export { CounseledYouthPagePlaceholder };

export const CounseledYouthPage = lazier(
  () => import('./CounseledYouthPage'),
  CounseledYouthPagePlaceholder,
);
